export const authPagesWithNoNavBarsList = ["confirmation", "about-us"];
export const unAuthPublicPagesWithHeaderNavbarList = [
  "active-campaigns",
  "campaign",
  "organization",
  "cause-project",
  "events",
  "event-payment"
];
